import { render } from "./TeacherRateModel.vue?vue&type=template&id=1ff81681"
import script from "./TeacherRateModel.vue?vue&type=script&lang=js"
export * from "./TeacherRateModel.vue?vue&type=script&lang=js"

import "./TeacherRateModel.vue?vue&type=style&index=0&id=1ff81681&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__